/* unplugin-vue-components disabled */import script from "./resourcePreview.vue?vue&type=script&setup=true&lang=js"
export * from "./resourcePreview.vue?vue&type=script&setup=true&lang=js"

import "./resourcePreview.vue?vue&type=style&index=0&id=2f433be2&lang=scss&scoped=true"
import "./resourcePreview.vue?vue&type=style&index=1&id=2f433be2&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f433be2"]])

export default __exports__